export default __webpack_public_path__ + "static/img3-c34d12b2102e3565fe6ce7cc876933cc.jpg";